
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[alias]/[pid]",
      function () {
        return require("private-next-pages/p/[alias]/[pid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[alias]/[pid]"])
      });
    }
  